import React, { useContext, useEffect, useState } from "react";
import localization from "../../../assets/localization/localization";
import Layout from "../../../components/sales/layout/layout";
import DivLayout from "../../../components/sales/divLayout/divLayout";
import DocumentView from "../../../components/sales/downloadDocView/documentView";
import ModalPop from "components/sales/modal/modal";
import ConstantInput from "../../../components/sales/Input/constantInput/constantInput";
import FileUpload from "../../../components/sales/fileUpload/fileUpload";
import { Button } from "react-bootstrap";
import CustomModal from "../../valetServices/modal";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import TableSection from "components/sales/tableSection/tableSection";

const ViewRequest = ({
  viewRequest,
  requestById = [],
  match,
  documentUploadUrlPublic,
  documentUrlDataPublic,
  approvalAction,
  requestedAction = [],
  requesttransactionList,
  requesttransactionListDetails = [],
  history,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState();
  const [isModal, setIsModal] = useState(false);
  const [remark, setRemark] = useState("");
  const [image, setImage] = useState("");
  const [count, setCount] = useState(0);
  const [url, setUrl] = useState();
  const [pageCount, setPageCount] = useState(0);
  const [listData, setListData] = useState();
  const role = JSON.parse(localStorage.getItem("roles"));
  const [roleId, setRoleId] = useState("");

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await viewRequest(match?.params?.id);
      await requesttransactionList(match?.params?.id);
      setIsLoading(false);
    })();
  }, []);

  const headers = [
    "Transaction Amount",
    "Wallet Type",
    "Remark",
    "Status",
    "Created at",
  ];

  useEffect(() => {
    if (
      requesttransactionListDetails &&
      requesttransactionListDetails?.data !== undefined &&
      requesttransactionListDetails?.data?.data !== undefined &&
      requesttransactionListDetails?.data?.data.length > 0
    ) {
      const tableData = [
        "id",
        "requested_amount",
        "wallet_type",
        "remark",
        "status",
        "created_at",
      ];
      const data = requesttransactionListDetails?.data?.data.map((element) =>
        Object.assign(
          ...tableData.map((key) =>
            key === "status" && parseInt(element["status"]) === 1
              ? { [key]: "Pending" }
              : key === "status" && parseInt(element["status"]) === 2
              ? { [key]: "Complete" }
              : key === "status" && parseInt(element["status"]) === 3
              ? { [key]: "Failed" }
              : { [key]: element[key] }
          )
        )
      );
      if (data) {
        data && setListData(data);
      }
      setPageCount(
        Math.ceil(
          requesttransactionListDetails?.data.total /
            requesttransactionListDetails?.data?.per_page
        )
      );
    }
  }, [requesttransactionListDetails]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await requesttransactionList(match?.params?.id);
    setIsLoading(false);
  };

  const handleModalHide = () => {
    setIsModal(false);
    window.location.reload();
  };

  const handleContinue = () => {
    (async () => {
      // setUrl(requestById?.wallet_type === 'INTERNAL' ? `${baseUrl}/wallet/approval/${requestById?.wallet_id}/${requestById?.subcategory}` : `${baseUrl}/wallet/approval/${requestById?.wallet_id}`)
      setUrl(`${baseUrl}/wallet-approval-listing`);
      setIsModal(false);
      const list = {};
      list["remarks"] = remark;
      list["doc"] = image;
      list["status"] = status;
      list["id"] = match?.params?.id;
      list["amount"] = match?.params?.amount;
      setIsLoading(true);
      await approvalAction(list);
      setIsLoading(false);
      setCount(count + 1);
      setStatus(1);
    })();
  };

  useEffect(() => {
    if (status !== "" && status !== undefined && parseInt(status) !== 1) {
      setIsModal(true);
    }
  }, [status]);

  return (
    <>
      <Layout title={localization.transactionRequestView} isLoading={isLoading} isGoback={true}>
        <div className="panel-card card-details" width="100%">
          {requestedAction !== null && requestedAction?.status !== 200 && (
            <CustomModal msg={requestedAction?.message} click={count} />
          )}
          {requestedAction !== null && requestedAction?.status === 200 && (
            <CustomModal
              msg={requestedAction?.message}
              isPageLoad={true}
              click={count}
              url={url}
              history={history}
            />
          )}
          <div className="panel-heading">{localization.RequestDetails}</div>
          <div className="panel-body">
            <div className="details-listing detail_alignment">
              <DivLayout heading={"ID"} data={requestById?.id} />

              <DivLayout heading={"Request By"} data={requestById?.name} />

              <DivLayout heading={"Amount"} data={requestById?.amount} />

              <DivLayout
                heading={"wallet Type"}
                data={requestById?.wallet_type}
              />

              {requestById?.category_name !== null && (
                <DivLayout
                  heading={"Category"}
                  data={requestById?.category_name}
                />
              )}

              {requestById?.subcategory !== null && (
                <DivLayout
                  heading={"Sub Category"}
                  data={requestById?.subcategory}
                />
              )}
              <DivLayout heading={"User Remark"} data={requestById?.remark} />

              {requestById?.utr_Cheque_no !== null && (
                <DivLayout
                  heading={"UTR Cheque No"}
                  data={requestById?.utr_Cheque_no}
                />
              )}

              {requestById?.approved_rejected_date !== null && (
                <DivLayout
                  heading={"Manager Action Date"}
                  data={requestById?.approved_rejected_date}
                />
              )}

              {requestById?.intermediate_remark !== null && (
                <DivLayout
                  heading={"Manager Action Remark"}
                  data={requestById?.intermediate_remark}
                />
              )}

              {requestById?.finance_date !== null && (
                <DivLayout
                  heading={"Finance Action Date"}
                  data={requestById?.finance_date}
                />
              )}

              {requestById?.finance_remark !== null && (
                <DivLayout
                  heading={"Finance Action Remark"}
                  data={requestById?.finance_remark}
                />
              )}

              {requestById?.created_at !== null && (
                <DivLayout
                  heading={"Created At"}
                  data={requestById?.created_at}
                />
              )}
            </div>
          </div>
        </div>

        {requestById?.user_attachment !== undefined &&
          requestById?.user_attachment[0] !== undefined &&
          requestById?.user_attachment[0]?.url !== undefined &&
          requestById?.user_attachment[0].url !== null && (
            <div className="panel-card card-details" width="100%">
              <div className="panel-heading">
                {localization.userUploadedDocument}
              </div>
              <div className="panel-body">
                <div className="details-listing detail_alignment">
                  <div className="row">
                    {requestById?.user_attachment.map((val) => {
                      return (
                        <>
                          {val?.url !== "" && val?.url !== null && (
                            <div className="col-md-4">
                              <DocumentView
                                title={localization.attachment}
                                attachment={val?.url}
                              />
                            </div>
                          )}
                        </>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          )}

        {requestById?.approved_rejected_attachment && (
          <div className="panel-card card-details" width="100%">
            <div className="panel-heading">{localization.uploadedDocument}</div>
            <div className="panel-body">
              <div className="details-listing detail_alignment">
                <div className="row">
                  {requestById?.approved_rejected_attachment.map((val) => {
                    return (
                      <>
                        {val?.url !== "" && val?.url !== null && (
                          <div className="col-md-4">
                            <DocumentView
                              title={localization.attachment}
                              attachment={val}
                            />
                          </div>
                        )}
                      </>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}

        {requestById?.finance_attachment && (
          <div className="panel-card card-details" width="100%">
            <div className="panel-heading">
              {localization.FinanceUploadedDocument}
            </div>
            <div className="panel-body">
              <div className="details-listing detail_alignment">
                <div className="row">
                  {requestById?.finance_attachment.map((val) => {
                    return (
                      <>
                        {val?.url !== "" && val?.url !== null && (
                          <div className="col-md-4">
                            <DocumentView
                              title={localization.attachment}
                              attachment={val}
                            />
                          </div>
                        )}
                      </>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}
        <ModalPop
          title={
            parseInt(status) === 3 || parseInt(status) === 5
              ? localization.rejectConf
              : parseInt(status) === 2 || parseInt(status) === 4
              ? localization.approvalConf
              : localization.conf
          }
          show={isModal}
          handleModalHide={handleModalHide}
        >
          <>
            <div className="modal-body">
              <div className="text-center">
                <h5>{localization.areYouSure}</h5>
                <div className="form-group">
                  <div className="col-sm-6">
                    <ConstantInput
                      label={localization.addRemark}
                      required
                      isStarRequired={true}
                      type="text"
                      handleChange={(val) => {
                        setRemark(val);
                      }}
                    />
                  </div>
                  <div className="col-sm-6">
                    <FileUpload
                      id="agreementContractUpload"
                      accept=".pdf,.png,.jpg"
                      documentUploadUrl={documentUploadUrlPublic}
                      documentUrlData={documentUrlDataPublic}
                      onChange={(val) => setImage(val)}
                      multiple={true}
                    >
                      <span className="btn btn-transparent">
                        {localization.uploadDocs}
                        {/* <span style={{color:'red'}}>*</span> */}
                      </span>
                    </FileUpload>
                  </div>
                </div>
                <Button
                  className="btn btn-primary"
                  onClick={() => handleContinue()}
                  disabled={!remark}
                >
                  {localization.continue}{" "}
                  <img src="../images/arrow-right.png" alt="" />
                </Button>
              </div>
            </div>
          </>
        </ModalPop>
        {parseInt(requestById?.status) !== 3 &&
          parseInt(requestById?.status) !== 4 &&
          parseInt(requestById?.status) !== 5 &&
          parseInt(requestById?.created_by) !==
            parseInt(JSON.parse(window.localStorage.loginDetails)?.id) && (
            <>
              <div className="container-fluid">
                <div className="text-center" style={{ display: "inline-flex" }}>
                  <Button
                    type="button"
                    onClick={() => {
                      setStatus(parseInt(requestById?.status) === 1 ? 2 : 4);
                    }}
                    style={{ marginRight: "14%" }}
                  >
                    Approve
                  </Button>
                  <Button
                    type="button"
                    onClick={() =>
                      setStatus(parseInt(requestById?.status) === 1 ? 3 : 5)
                    }
                  >
                    Reject
                  </Button>
                </div>
              </div>
            </>
          )}
        {match?.params?.id !== undefined && (
          <>
            <h5>Transaction Details Against Request</h5>
            <TableSection
              data={listData}
              isId={false}
              isMngId={false}
              headers={headers}
              pageCount={pageCount}
              onPageChange={onPageChange}
              detailList={
                requesttransactionListDetails?.data &&
                requesttransactionListDetails?.data
              }
              srNo={requesttransactionListDetails?.from}
            />
          </>
        )}
      </Layout>
    </>
  );
};

export default ViewRequest;
